import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class FooterMenusApi extends Api {
  constructor() {
    super('website/footer_menus/');
  }

  list = (params = {}) => {
    return this.buildQuery('get', { params });
  };

  show = (id) => {
    return this.buildQuery('get', {}, id);
  };

  create = (data) => {
    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/footer_menus`,
      method: 'POST',
      data: { footer_menu: data },
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  update = (id, data) => {
    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/footer_menus/${id}`,
      method: 'PUT',
      data: { footer_menu: data },
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  destroy = (id) => {
    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/footer_menus/${id}`,
      method: 'DELETE',
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  getFilters = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/filters`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default new FooterMenusApi();
